"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const math = require("mathjs");
const uris = require("../globals/uris");
const constraint_1 = require("../model/constraint");
const variable_1 = require("../model/variable");
const expression_1 = require("../model/expression");
const expressiontools_1 = require("../math/expressiontools");
class ConstraintLoader {
    constructor(store) {
        this.store = store;
    }
    loadConstraints(constraintUris) {
        let constraints = constraintUris.map(c => this.createConstraint(c));
        return constraints; //_.zipObject(constraintUris, constraints);
    }
    createConstraint(constraintUri) {
        let vars = [];
        let body = this.recursiveLoadBoundVariables(constraintUri, vars);
        return new constraint_1.Constraint(vars, this.loadExpression(body));
    }
    //returns the body of the innermost bound variable (the meat of the expression)
    recursiveLoadBoundVariables(expressionUri, vars) {
        let expressionType = this.store.findObject(expressionUri, uris.TYPE);
        if (this.store.isSubclassOf(expressionType, uris.QUANTIFIER)) {
            let varUri = this.store.findObject(expressionUri, uris.VARS);
            let body = this.store.findObject(expressionUri, uris.BODY);
            vars.push(this.loadVariable(varUri));
            return this.recursiveLoadBoundVariables(body, vars);
        }
        return expressionUri;
    }
    loadVariable(varUri) {
        let varName = this.store.findObjectValue(varUri, uris.VAR_NAME);
        let varType = this.store.findObject(varUri, uris.VAR_TYPE);
        let varExpr = this.store.findObject(varUri, uris.VAR_EXPR);
        let values = this.store.findAllObjects(varUri, uris.VAR_VALUE);
        if (varExpr) {
            return new variable_1.ExpressionVariable(varName, varType, this.loadExpression(varExpr));
        }
        else if (values.length > 0) {
            return new variable_1.SetBasedVariable(varName, values);
        }
        return new variable_1.TypedVariable(varName, varType);
    }
    loadExpression(expressionUri) {
        if (expressionUri) {
            let isDirected = this.store.findObjectValue(expressionUri, uris.DIRECTED);
            return new expression_1.Expression(null, isDirected, this.recursiveLoadExpression(expressionUri));
        }
    }
    recursiveLoadExpression(expressionUri) {
        let expressionType = this.store.findObject(expressionUri, uris.TYPE);
        //console.log(expressionUri, expressionType)
        if (this.store.isSubclassOf(expressionType, uris.BINARY_OPERATOR)) {
            let left = this.recursiveLoadExpression(this.store.findObject(expressionUri, uris.LEFT));
            let right = this.recursiveLoadExpression(this.store.findObject(expressionUri, uris.RIGHT));
            return expressiontools_1.ExpressionTools.toOperatorNode(expressionType, [left, right]);
        }
        else if (expressionType === uris.FUNCTIONAL_TERM) {
            let funcObj = this.store.findObject(expressionUri, uris.FUNC);
            let fn;
            if (this.store.findObject(funcObj, uris.TYPE) === uris.NAMED_FUNCTION) {
                fn = this.store.findObjectValue(funcObj, uris.NAME);
            }
            else {
                fn = this.recursiveLoadExpression(funcObj);
            }
            let args = this.recursiveLoadExpression(this.store.findObject(expressionUri, uris.ARGS));
            return new math.expression.node.FunctionNode(fn, [args]);
        }
        else if (expressionType === uris.ACCESSOR) {
            let object = this.store.findObjectValue(expressionUri, uris.OBJECT);
            let property = this.store.findObjectValue(expressionUri, uris.PROPERTY);
            let objectNode = new math.expression.node.SymbolNode(object);
            let indexName = new math.expression.node.ConstantNode(property);
            let indexNode = new math.expression.node.IndexNode([indexName], true);
            return new math.expression.node.AccessorNode(objectNode, indexNode);
        }
        else if (expressionType === uris.VARIABLE) {
            let name = this.store.findObjectValue(expressionUri, uris.VAR_NAME);
            return new math.expression.node.SymbolNode(name);
        }
        else if (expressionType === uris.CONDITIONAL) {
            const { ConditionalNode } = math.expression.node;
            const [condition, trueExpr, falseExpr] = [
                uris.ANTECEDENT,
                uris.CONSEQUENT,
                uris.ALTERNATIVE
            ].map(uri => this.recursiveLoadExpression(this.store.findObject(expressionUri, uri)));
            return new ConditionalNode(condition, trueExpr, falseExpr);
        }
        else {
            let value = this.store.findObjectValue(expressionUri, uris.VALUE);
            return new math.expression.node.ConstantNode(value);
        }
    }
}
exports.ConstraintLoader = ConstraintLoader;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/io/constraintloader.js
// module id = 1301
// module chunks = 3